import { showError } from "../constants/toasts";

export const handleExport = async (
  exportPromise: Promise<any>,
  name: string
) => {
  const date = new Date().toISOString();
  try {
    const response = await exportPromise;
    // console.log(response,'responseresponse')
    if (response) {
      const blob = new Blob([response.data], {
        type: "application/octet-stream",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${name}_export_${date}.csv`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }
  } catch (error: any) {
    console.error("Error exporting:", error);
    showError(error?.data?.message);
  }
};
